module.exports = __webpack_public_path__ + "static/media/surper-3.906fef74.jpg";